var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-diamond 3",
    clipPath: "url(#clip0_6335_3650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4931 5.99656L0.5 11.9931L6.50001 17.9966L12.5 24L18.5 17.9966L24.5 11.9931L18.5069 5.99656C15.2107 2.69845 12.5076 0 12.5 0C12.4924 0 9.78929 2.69845 6.4931 5.99656ZM7.71928 7.22344L2.95236 11.9931L7.72619 16.7697L12.5 21.5462L17.2738 16.7697L22.0476 11.9931L17.2807 7.22344C14.6589 4.60012 12.5076 2.45376 12.5 2.45376C12.4924 2.45376 10.3411 4.60012 7.71928 7.22344ZM11.6458 10.1183V13.6198H12.5H13.3542V10.1183V6.61689H12.5H11.6458V10.1183ZM11.6458 16.5698V17.3693H12.5H13.3542V16.5698V15.7703H12.5H11.6458V16.5698Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6335_3650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningOutline);
export default __webpack_public_path__ + "static/media/icon--warning-outline.893fbc7b0348588e2ed41b8364dfc0cb.svg";
export { ForwardRef as ReactComponent };